import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ViewportState {
  isMobileSize: boolean;
  width: number;
}

const initialtState: ViewportState = {
  isMobileSize: false,
  width: 0
};

export const viewportSlice = createSlice({
  name: 'viewport',
  initialState: initialtState,
  reducers: {
    updateViewport(state, action: PayloadAction<{ width: number }>) {
      state.width = action.payload.width;
      state.isMobileSize = action.payload.width <= 760; // Threshold
    }
  }
});

export const ViewportActions = viewportSlice.actions;
export const ViewportReducer = viewportSlice.reducer;
